var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-body" },
    [
      _c("page-banner", _vm._b({}, "page-banner", _vm.page.banner, false)),
      _vm.production
        ? _c(
            "section",
            {
              staticClass: "page-section product-line-section",
              attrs: { id: "s-production-line" }
            },
            [
              _c("page-limiter", [
                _c("h2", { staticClass: "page-section__title" }, [
                  _vm._v(_vm._s(_vm.production.title))
                ]),
                _c("p", { staticClass: "page-section__caption" }, [
                  _vm._v(_vm._s(_vm.production.caption))
                ])
              ]),
              _vm.production.items && _vm.production.items.length
                ? [
                    _c("product-line-carousel", {
                      directives: [
                        { name: "scroll-reveal", rawName: "v-scroll-reveal" }
                      ],
                      attrs: { items: _vm.production.items }
                    })
                  ]
                : _vm._e(),
              _vm.production.linkAll
                ? _c(
                    "div",
                    { staticClass: "page-section__foot" },
                    [
                      _c(
                        "btn",
                        {
                          staticClass: "btn btn--primary page-section-btn",
                          attrs: {
                            tag: "link",
                            link: _vm.production.linkAll.link
                          }
                        },
                        [
                          _vm._v(
                            "\n\t\t\t\t" +
                              _vm._s(_vm.production.linkAll.title) +
                              "\n\t\t\t\t"
                          ),
                          _c("icon-arrow", {
                            staticClass: "page-section-btn__icon"
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e()
            ],
            2
          )
        : _vm._e(),
      _vm.page.newsBox
        ? _c(
            "section",
            {
              directives: [
                { name: "scroll-reveal", rawName: "v-scroll-reveal" }
              ],
              staticClass: "page-section news-section"
            },
            [
              _c(
                "page-limiter",
                [_c("news-box", { attrs: { content: _vm.page.newsBox } })],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "section",
        {
          directives: [{ name: "scroll-reveal", rawName: "v-scroll-reveal" }],
          staticClass: "page-section learn-shops-section"
        },
        [
          _c(
            "page-limiter",
            [
              _c("feedback-tile", {
                attrs: { ya_metrica_goal: "main_request" }
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-29ec7794", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-29ec7794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageHome.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-29ec7794","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/pages/PageHome.vue
// module chunks = 0